import { useSelector } from "react-redux";

const useReducerHook = () => {

  const productData = useSelector((state) => state.productData);
  const productFilter = useSelector((state) => state.productFilter);
  const userCartDetails = useSelector((state) => state.userCartDetails);
  const userDetails = useSelector((state) => state.userDetails);
  const blogFilter = useSelector((state) => state.blogFilter);
  const settingsData = useSelector((state) => state.settingsData);
  const mainCategory = useSelector((state) => state.mainCategory);
  // 
  const pageData = useSelector((state) => state.pageData);
  const pageMenus = useSelector((state) => state.pageMenus);
  return {
    pageData,
    pageMenus,
    productData,
    productFilter,
    userCartDetails,
    userDetails,
    blogFilter,
    mainCategory,
    settingsData

  };
};

export default useReducerHook;
